import { useState } from "react";
import { selectionScenarios } from "@/mocks/fengchiData";

export default function SelectionGuide() {
  const [activeKey, setActiveKey] = useState(selectionScenarios[0].key);
  const active = selectionScenarios.find((s) => s.key === activeKey) ?? selectionScenarios[0];

  return (
    <section id="guide" className="py-14 md:py-20 bg-background-50">
      <div className="px-4 md:px-6">
        <div className="max-w-3xl">
          <span className="inline-flex items-center gap-2 text-accent-600 text-sm font-medium">
            <i className="ri-compass-3-line" />
            选片指南
          </span>
          <h2 className="mt-3 font-heading text-2xl md:text-4xl font-bold text-foreground-950">
            按今晚的场景，挑一部合适的
          </h2>
          <p className="mt-4 text-foreground-700 text-sm md:text-base leading-relaxed">
            同一部作品，在不同的场合看感受完全不同。先想清楚今晚是独自安静、还是和家人朋友一起，
            再从下面挑一部——每一类都附上了推荐理由和参考评分，省去反复纠结的时间。
          </p>
        </div>

        <div className="mt-6 md:mt-8 flex flex-wrap gap-2">
          {selectionScenarios.map((scenario) => {
            const isActive = scenario.key === activeKey;
            return (
              <button
                key={scenario.key}
                type="button"
                onClick={() => setActiveKey(scenario.key)}
                aria-pressed={isActive}
                className={`inline-flex items-center gap-2 px-4 py-2.5 rounded-md border text-sm transition-colors cursor-pointer whitespace-nowrap ${
                  isActive
                    ? "bg-secondary-500 border-secondary-500 text-background-50"
                    : "bg-background-100 border-background-300 text-foreground-700 hover:border-secondary-400"
                }`}
              >
                <i className={`${scenario.icon} text-base`} />
                {scenario.label}
              </button>
            );
          })}
        </div>

        <div className="mt-6 md:mt-8 rounded-lg border border-background-200 bg-background-100 p-5 md:p-8">
          <div className="flex items-start gap-3">
            <span className="w-11 h-11 shrink-0 flex items-center justify-center rounded-md bg-primary-500 text-background-50">
              <i className={`${active.icon} text-xl`} />
            </span>
            <div>
              <h3 className="font-heading text-lg md:text-xl font-bold text-foreground-950">
                {active.label}推荐
              </h3>
              <p className="mt-1 text-sm text-foreground-600">{active.desc}</p>
            </div>
          </div>

          <div className="mt-6 grid grid-cols-1 md:grid-cols-3 gap-4">
            {active.picks.map((pick) => (
              <div
                key={pick.title}
                className="rounded-lg border border-background-200 bg-background-50 p-4 flex flex-col"
              >
                <div className="flex items-center justify-between">
                  <h4 className="font-heading text-base md:text-lg font-bold text-foreground-950">
                    {pick.title}
                  </h4>
                  <span className="inline-flex items-center gap-1 px-2 py-0.5 rounded-md bg-accent-100 text-accent-800 text-xs font-bold">
                    <i className="ri-star-fill" />
                    {pick.score}
                  </span>
                </div>
                <p className="mt-2.5 text-sm text-foreground-600 leading-relaxed flex-1">
                  {pick.reason}
                </p>
                <a
                  href="#works"
                  className="mt-3 inline-flex items-center gap-1 text-xs text-primary-700 hover:text-primary-800 cursor-pointer whitespace-nowrap"
                >
                  查看作品详情
                  <i className="ri-arrow-right-line" />
                </a>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}